module.exports = __webpack_public_path__ + "static/greyelephteether-dd91c8a3b91c0035742a0b397a1efa65.jpeg";